/**
 * 已下市股票靜態映射
 * 用於處理已下市但仍存在於歷史交易記錄中的股票
 */

export interface DelistedStock {
  symbol: string;
  name: string;
  delistedDate?: string;
  reason?: string;
  newSymbol?: string; // 如果有合併或更名，記錄新代號
  notes?: string;
}

/**
 * 已下市股票清單
 */
export const DELISTED_STOCKS: Record<string, DelistedStock> = {
  '2888': {
    symbol: '2888',
    name: '新光金',
    delistedDate: '2024-01-01', // 需要確認實際下市日期
    reason: '下市',
    notes: '新光金控已下市，不再於證交所交易'
  },
  
  // 可以在這裡添加更多已下市的股票
  // '1234': {
  //   symbol: '1234',
  //   name: '範例公司',
  //   delistedDate: '2023-12-31',
  //   reason: '合併',
  //   newSymbol: '5678',
  //   notes: '已與5678公司合併'
  // }
};

/**
 * 檢查股票是否已下市
 * @param symbol 股票代號
 * @returns 是否已下市
 */
export function isDelistedStock(symbol: string): boolean {
  return symbol in DELISTED_STOCKS;
}

/**
 * 取得已下市股票資訊
 * @param symbol 股票代號
 * @returns 下市股票資訊，如果不存在則返回 null
 */
export function getDelistedStockInfo(symbol: string): DelistedStock | null {
  return DELISTED_STOCKS[symbol] || null;
}

/**
 * 取得已下市股票名稱
 * @param symbol 股票代號
 * @returns 股票名稱，如果不存在則返回 null
 */
export function getDelistedStockName(symbol: string): string | null {
  const delistedStock = DELISTED_STOCKS[symbol];
  return delistedStock ? delistedStock.name : null;
}

/**
 * 取得所有已下市股票
 * @returns 所有已下市股票的陣列
 */
export function getAllDelistedStocks(): DelistedStock[] {
  return Object.values(DELISTED_STOCKS);
}
